import {Component, OnDestroy, OnInit} from '@angular/core';
import {TableService, VisitedService} from "@amlCore/services";
import {Subject} from 'rxjs';
import {takeUntil} from "rxjs/operators";
import {DictionariesService} from "../../../service/dictionaries.service";
import { TableController } from "@amlCore/tableController";
import {Utils} from "@amlCore/utils";
import {QrefFArx} from "../../../../../../api/build";

@Component({
  selector: 'app-dictionary-qref-f-arx',
  templateUrl: './qrefFArx.component.html'
})
export class QrefFArxComponent extends TableController implements OnInit, OnDestroy {
  data: QrefFArx[] = [];
  goBack = Utils.goBack;
  isShowVisited = false;
  isSetFocus = false;

  private destroy$ = new Subject<void>();

  constructor(protected dictSrv: DictionariesService,
              protected visitedService: VisitedService,
              protected tableService: TableService
              ) {
    super(visitedService, tableService);
  }

  ngOnInit() {
    this.loadDict();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadDict() {
    // Данные справочника при последующих вызовах берутся из sessionStorage
    this.dictSrv.getQrefFArxList().pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.data = data.content;
    });
  }
  
  onPageChange(params): void {
    this.loadDict();
  }
}


